import axios from 'axios';

// API temel URL'si
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Axios instance oluşturma
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// İstek interceptor'u - auth token vs. eklenebilir
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Yanıt interceptor'u
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Hata işleme logiği
    // console.error('API error:', error);
    return Promise.reject(error);
  }
);

export default api; 